// src/components/About.js
import React from 'react';

const About = () => {
  return (
    <section id="about" className="topics-section">
      <div className="container">
        <div className="section-header fade-in">
          <h2><i className="fas fa-robot me-2"></i>About the Symposium</h2>
        </div>
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="topic-card fade-in">
              <div className="text-center">
                {/* <i className="fas fa-network-wired topic-icon"></i> */}
                <p style={{textAlign: 'justify'}}>
                  The rapid ascent of artificial intelligence (AI) and information technology (IT) has fundamentally
                  transformed the way we interact, communicate, learn, and conduct research. As digital landscapes
                  expand and computational tools become increasingly sophisticated, the traditional boundaries of
                  the social sciences are being redrawn. The National Symposium on Re-examining the Social
                  Sciences Through the Lens of Artificial Intelligence & Information Technology is conceived as
                  a pioneering platform for scholars, technologists, policymakers, and students to engage in critical
                  dialogue about the evolving role of digital innovation in social inquiry.
                </p>
                <p style={{textAlign: 'justify'}} className="m-0">
                  This event aspires to spark new ideas, cultivate interdisciplinary collaborations, and challenge
                  conventional paradigms by exploring how AI and IT can both illuminate and complicate social
                  realities. It is an invitation to reimagine methodologies, redefine ethical frameworks, and
                  rearticulate the social contract in an era of algorithmic influence.
                </p>
                {/* <p className="lead mb-0">
                  Join us for a groundbreaking symposium that explores the transformative impact of 
                  Artificial Intelligence on social sciences. This event brings together leading researchers, 
                  practitioners, and thought leaders to discuss innovative approaches to social inquiry in the digital age.
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;